import { call, put } from 'redux-saga/effects';
import {
  disconnectProviderFailure,
  disconnectProviderSuccess,
} from '../actions';
import { disconnectProvider } from '../api';
import { DisconnectProviderRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { fetchMeRequest } from 'store/auth/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* disconnectAccountSaga(
  action: DisconnectProviderRequestAction
) {
  try {
    let err: ApiError | null;

    const { provider, providerFormattedName } = action.payload;
    const response: ApiResponse = yield call(disconnectProvider, provider);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('notifications.disconnected'),
      description: i18n.t('notifications.provider-disconnected-successfully', {
        provider: providerFormattedName,
      }),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(disconnectProviderSuccess());
    yield put(fetchMeRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(disconnectProviderFailure());
  }
}
